module.exports = __webpack_public_path__ + "fonts/SharpSans-No1-Semibold.woff2";